import apiService from "../../ApiService";

export const boostEligibility = () => {
  return apiService.get<{ isEligible: boolean }>({
    path: `v1/store/ericsson/eligibility`,
  });
};
